module.exports = __webpack_public_path__ + "static/media/Manual_sencer_EN-19.9def6994.png";